var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-8 w-8 stroke-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0\n    01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }